import ApplyBulkItemActionRequest from 'owa-service/lib/contract/ApplyBulkItemActionRequest';
import ApplyBulkItemActionResponse from 'owa-service/lib/contract/ApplyBulkItemActionResponse';
import BulkTriageActionType from 'owa-service/lib/contract/BulkTriageActionType';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import applyBulkItemActionOperation from 'owa-service/lib/operation/applyBulkItemActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import KeepNType from 'owa-service/lib/contract/KeepNType';
import ApplyBulkItemActionJsonRequest from 'owa-service/lib/contract/ApplyBulkItemActionJsonRequest';
import applyBulkItemActionRequest from 'owa-service/lib/factory/applyBulkItemActionRequest';
import { RuleBulkActionCustomData } from '../orchestrators/runRuleNowOrchestrator';

/**
 * Apply bulk item action service
 * @param actionType the bulk action type
 * @param emailAddresses emailaddresses
 * @param sourceFolderId the source folderId
 * @param keepNType whether to keep last N items or use dateTime
 * @param keepNCount number of items to keep or date to keep items that are more recent
 * @param destinationFolderId the folder to move the items to
 * @param customData custom data to use in the bulk action manager
 * @return the ApplyBulkItemActionResponse
 */
export default function applyBulkItemActionService(
    actionType: BulkTriageActionType,
    emailAddresses: EmailAddressWrapper[],
    sourceFolderId: string,
    keepNType: KeepNType,
    keepNCount: number,
    destinationFolderId?: string,
    customData?: RuleBulkActionCustomData
): Promise<ApplyBulkItemActionResponse> {
    const requestBody = applyBulkItemActionRequest(<ApplyBulkItemActionRequest>{
        ActionType: BulkTriageActionType.Move,
        DestinationFolderId: { Id: destinationFolderId },
        EmailAddresses: emailAddresses,
        SourceFolderId: { Id: sourceFolderId },
        CountType: keepNType,
        KeepNCount: keepNCount,
        BulkActionRequest: true,
        BulkActionCustomData: JSON.stringify(customData),
    });

    return applyBulkItemActionOperation(<ApplyBulkItemActionJsonRequest>{
        Header: getJsonRequestHeader(),
        Body: requestBody,
    });
}
